import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/79a00700-ea25-4994-9595-b1f56271911f";
export const REGISTER_URL = "https://a.ntrk2.com/bf6e64f8-87d4-4df7-bfe5-ba45f52ffac4";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gamph.loadprkw2a.com/download?openExternalBrowser=1&id=yiy3sobwz5lq7xw";

export * from "./codes";
export * from "./context";
